<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import { TicketsPath, CityPath, USERSPATH } from "../../../../../path";
import axios from "axios";
import Swal from "sweetalert2";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";

export default {
  components: {
    Layout,
    PageHeader,
    SelectWithSearch,
    DeleteIcon,
  },
  data() {
    return {
      title: "Category Assignee",
      items: [
        {
          text: "List",
        },
        {
          text: "Category Assignee",
          active: true,
        },
      ],
      filter: [],
      key: 0,
      form: {
        level: 1,
      },
      assign_by: "by_user",
      currentPage: 1,
      search: "",
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      set_role: "Others",
      fields: [
        "category",
        "assignee",
        "role",
        "city",
        "escalation_level",
        "actions",
      ],
      category_assignees: [],
      escalation_options: [
        { value: 1, text: "Escalation Level 1" },
        { value: 2, text: "Escalation Level 2" },
        { value: 3, text: "Escalation Level 3" },
        { value: 4, text: "Escalation Level 4" },
      ],
      options: [
        { value: null, text: "Select Category" },
        { value: "supply", text: "Supply" },
        { value: "payout", text: "Payout" },
        { value: "pos", text: "Pos" },
        { value: "signage", text: "Signage" },
        { value: "outlet_ops", text: "Outlet Ops" },
        { value: "retraining", text: "Retraining" },
        { value: "product_suggestion", text: "Product Suggestion" },
        { value: "others", text: "Others" },
      ],
    };
  },

  watch: {
    search() {
      this.getCategoryAssignee();
    },
    currentPage() {
      this.getCategoryAssignee();
    },
  },
  computed: {
    TicketsPath() {
      return TicketsPath;
    },
    CityPath() {
      return CityPath;
    },
    USERSPATH() {
      return USERSPATH;
    },
  },
  methods: {
    addUser() {
      this.$bvModal.show("bv-add-user");
      this.selectedUser = {};
      this.key += 1;
    },
    async getCategoryAssignee() {
      try {
        let res = await axios.get(this.base_url + TicketsPath.GET_ASSINGEES, {
          params: {
            search: this.search,
            page: this.currentPage,
          },
        });
        if (res.data.status) {
          this.category_assignees = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveCategoryAssginee() {
      try {
        if (!this.form.category) {
          Swal.fire("Please Fill the required field", "", "error");
          return;
        }
        let res = await axios.post(
          this.base_url + TicketsPath.SAVE_ASSIGNEES,
          this.form
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.form = {};
          this.getCategoryAssignee();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteCategoryAssignee(v) {
      try {
        let res = await axios.post(
          this.base_url + TicketsPath.DELETE_ASSIGNEES,
          {
            id: v.id,
          }
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
          this.getCategoryAssignee();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.getCategoryAssignee();
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col sm="4">
                <b-form-group label="Category:">
                  <b-form-select
                    v-model="form.category"
                    :options="options"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Escalation Level:">
                  <b-form-select
                    v-model="form.level"
                    :options="escalation_options"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Assgin By:">
                  <b-form-radio
                    v-model="assign_by"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="by_user"
                    >Assign By User</b-form-radio
                  >
                  <b-form-radio
                    v-model="assign_by"
                    :aria-describedby="ariaDescribedby"
                    name="some-radios"
                    value="by_role"
                    >Assign By Role</b-form-radio
                  >
                </b-form-group>
              </b-col>
              <template v-if="assign_by == 'by_user'">
                <b-col sm="4">
                  <b-form-group label="Assginee:">
                    <SelectWithSearch
                      :search_api="TicketsPath.SEARCH_USERS"
                      track_by="id"
                      display="name"
                      @selectedOption="(v) => (form.user_id = v)"
                    ></SelectWithSearch>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label="City:">
                    <SelectWithSearch
                      :search_api="CityPath.GET_CITY"
                      track_by="city"
                      display="city"
                      @selectedOption="(v) => (form.city = v)"
                    ></SelectWithSearch>
                  </b-form-group>
                </b-col>
              </template>
              <template v-else>
                <b-col sm="4">
                  <b-form-group label="Role:">
                    <SelectWithSearch
                      :search_api="USERSPATH.GET_ROLES"
                      track_by="id"
                      display="name"
                      @selectedOption="(v) => (form.role_id = v)"
                    ></SelectWithSearch>
                  </b-form-group>
                </b-col>
              </template>
              <b-col>
                <b-button
                  class="mt-4"
                  variant="success"
                  @click="saveCategoryAssginee"
                  >Save Assignee</b-button
                >
              </b-col>
            </b-row>
            <div class="row mb-4">
              <div class="col-sm-12">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="category_assignees.key"
                :items="category_assignees.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(assignee)="row">
                  {{ row.item.user?.name }}
                </template>
                <template v-slot:cell(role)="row">
                  {{ row.item.role?.name }}
                </template>
                <template v-slot:cell(escalation_level)="row">
                  Escalation Level {{ row.item.level }}
                </template>
                <template v-slot:cell(actions)="row">
                  <div style="display: flex; gap: 0px">
                    <div
                      v-if="
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'TicketCategoryAssignee'
                        ).length > 0 ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="deleteCategoryAssignee(row.item)"
                    >
                      <DeleteIcon />
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="category_assignees.key"
                      v-model="currentPage"
                      :total-rows="category_assignees.total"
                      :per-page="category_assignees.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style></style>
